import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from "react-router-dom"
import { enquireScreen } from 'enquire-js'
import Header from './pages/Layout/Nav3'
import Footer from './pages/Layout/Footer0'
import Layout from './pages/Layout'
import Taxa from './pages/Taxa'
import Data from './pages/Data'
import Home from './pages/Home'
import NotFound from './pages/NotFound'

import Help from './pages/Help'
import SpeciesDetail from './pages/SpeciesDetail'; // 物种详情页组件
import SampleDetail from './pages/SampleDetail'; // 样本详情页组件
import PathogenicAnalysis from './pages/PathogenicAnalysis'; // 致病菌分析页
import PathogenicDetail from './pages/PathogenicDetail'; // 致病菌详情页
import Shu from './pages/Shu'; // 致病菌详情页
import ShuDetail from './pages/ShuDetail'; // 致病菌详情页

import {
  Nav30DataSource,
  Footer00DataSource,
} from './pages/Layout/data.source.js'


let isMobile
enquireScreen((b) => {
  isMobile = b
});

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile,
    }
  }
  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b })
    });
  }
  render() {
    return (
      <Router>
        <div>
          <div style={{ height: '64px', background: '#fff' }}></div>
          <Header dataSource={Nav30DataSource} isMobile={this.isMobile} />
          <Route exact path="/" component={Home} />
         
          <Route exact path="/taxa" component={Taxa} />
          <Route exact path="/data" component={Data} />
          <Route exact path="/help" component={Help} />
          <Route exact path="/notfound" component={NotFound} />
          <Route path="/species/:id" component={SpeciesDetail} />
          <Route path="/sample/:run" component={SampleDetail} />
          <Route exact path="/pathogenic" component={PathogenicAnalysis} />
          <Route path="/pathogenic/:run" component={PathogenicDetail} />
          <Route exact path="/shu" component={Shu} />
          <Route path="/shu/:run" component={ShuDetail} />
          <Footer dataSource={Footer00DataSource} isMobile={this.isMobile} />
        </div>
      </Router>
    )
  }
}

export default App